<template>
  <section class="step-header">
    <h3
      v-if="title"
      class="step-header__title">{{ title }}</h3>
    <h4
      v-if="subtitle"
      :class="{'step-header__subtitle--large-mobile': subtitleLargeMobile}"
      class="step-header__subtitle">{{ subtitle }}</h4>
    <div
      v-if="$slots.default"
      class="step-header__slot"
    >
      <slot/>
    </div>
  </section>
</template>

<script>
/**
 * <step-header></step-header>
 * @desc step title / subtitle
 */
export default {
  // Name
  name: 'step-header',

  // Props
  props: {
    title: String,
    subtitle: String,
    subtitleLargeMobile: Boolean
  }
}
</script>

<style scoped lang="scss">
.step-header {
  width: 100%;
  padding: 28px 0px;

  @include breakpoint('tablet-portrait-up') {
    padding: 45px 0;
  }

  @include breakpoint('desktop-up') {
    padding: 30px 0 0 0;
  }

  &__title {
    text-align: center;
    font-family: 'Open Sans', sans-serif;
    line-height: 1.5;
    color: $theme-text-grey-dark;
    margin: 0 15px;
    font-weight: 700;
    letter-spacing: 0.01em;
    white-space: pre-line;
  }

  &__subtitle {
    text-align: center;
    font-family: 'Open Sans', sans-serif;
    line-height: 1.5;
    font-size: 10px;
    font-weight: 400;
    margin: 15px 0 0;
    white-space: pre-line;

    &--large-mobile {
      font-size: 14px;
      letter-spacing: 0.010em;
    }

    @include breakpoint('tablet-portrait-up') {
      font-size: 16px;
      color: $theme-text-grey-dark;
      letter-spacing: 0;
    }

    @include breakpoint('desktop-up') {
      font-size: 20px;
    }
  }
}
</style>
